import LoadingButton from "@/components/common/form/loading-button";
import SiteTypeIcon from "@/components/site/site-type-icon";
import { getSiteTypeName } from "@/utils/common";
import { ExternalLink } from "lucide-react";
import React from "react";

const BLOG_URL = process.env.NEXT_PUBLIC_BLOG_URL;
interface ISixshopProOnboardingScriptProps {
  prefixGtmId: string;
  publicId: string;
  onFinish: () => void;
  initialSiteUrl?: string | null;
  nextText?: string;
  isTeamOnboarding?: boolean;
}

const SixshopProOnboardingScript = ({
  onFinish,
  nextText = "확인",
  prefixGtmId,
}: ISixshopProOnboardingScriptProps) => {
  return (
    <div className="w-104">
      <div className="flex flex-col p-8 mt-1 text-center center-center bg-cb-gray-50">
        <div className="flex my-8 center-center">
          <SiteTypeIcon siteType="SIXSHOP_PRO" width={145} height={30} />
        </div>

        <div className="mb-9 mt-9 text-cb-gray-700 break-keep">
          <span className="">
            공통 스크립트 설치 완료 상태라도 만든 캠페인이 웹사이트에서 한 번도
            노출되지 않았다면 미설치로 안내될 수 있어요. 아래 방법을 따라 해결할
            수 있어요.
          </span>
        </div>

        <div className="mb-9">
          <ol className="flex flex-col gap-1 pl-4 mt-4 text-left list-decimal">
            <li>
              식스샵 프로 &apos;웹사이트 디자인하기&apos;에서 캠페인 추가하고
              등록하기
            </li>
            <li>내 웹사이트에서 캠페인 노출되는 것 확인하기</li>
            <li>
              공통 스크립트 설치 완료 상태로 안내되는 것이 확인되면, 필요에 따라
              노출한 캠페인을 계속 공개 상태로 유지하거나 비공개로 변경하기
            </li>
          </ol>
        </div>

        <a
          href={`${BLOG_URL}/%EC%8B%9D%EC%8A%A4%EC%83%B5-%ED%94%84%EB%A1%9C-%EC%82%AC%EC%9A%A9%EC%9E%90%EB%A5%BC-%EC%9C%84%ED%95%9C-%EC%BD%94%EB%93%9C%EC%95%A4%EB%B2%84%ED%84%B0-%EC%82%AC%EC%9A%A9-%EA%B0%80%EC%9D%B4%EB%93%9C/`}
          target="_blank"
          data-gtm-id={`${prefixGtmId}_script_guide`}
          className="inline-flex w-fit gap-2 px-4 border rounded-md center-center h-9 border-cb-gray-900 min-w-[209px]"
        >
          {getSiteTypeName("SIXSHOP_PRO")} 가이드 바로가기
          <ExternalLink className="w-4 h-4" />
        </a>
      </div>
      <div className="mt-8">
        <LoadingButton
          theme="primary"
          block
          onClick={onFinish}
          data-gtm-id={`${prefixGtmId}_script_self_install_script_next`}
        >
          {nextText}
        </LoadingButton>
      </div>
    </div>
  );
};

export default React.memo(SixshopProOnboardingScript);
